export const faqTax = [
  {
    title : "faq_tax_title_1",
    description: "faq_tax_description_1"
  },
  {
    title : "faq_tax_title_2",
    description: "faq_tax_description_2"
  },
  {
    title : "faq_tax_title_3",
    description: "faq_tax_description_3"
  },
  {
    title : "faq_tax_title_4",
    description: "faq_tax_description_4"
  },
  {
    title : "faq_tax_title_5",
    description: "faq_tax_description_5"
  },
  {
    title : "faq_tax_title_6",
    description: "faq_tax_description_6"
  }
]